export enum Protocol {
	V1 = 'V1',
	V2 = 'V2',
	MIXED = 'MIXED',
}
